import * as React from 'react';
import styled from 'styled-components';
import { Avatar, SkeletonAvatar, Text, theme } from 'components';
import { StyledSkeletonInput } from './commonStyled';

export interface NameCellProps {
  loading?: boolean;
  firstName?: string;
  lastName?: string;
  avatarFilestackId?: string;
}

const NameCell: React.FC<NameCellProps> = ({
  loading,
  firstName,
  lastName,
  avatarFilestackId,
}) => loading ? (
    <>
      <StyledAvatarSkeleton size="default" />
      <StyledSkeletonInput size="small" />
    </>
  ) : (
    <>
      <StyledContactsAvatar user={{ firstName, lastName, avatarFilestackId }} />
      <StyledFullNameText>
        {firstName} {lastName}
      </StyledFullNameText>
    </>
  );

export default React.memo(NameCell);

const StyledContactsAvatar = styled(Avatar)`
  background-color: ${theme.gray6};
  color: ${theme.white};
  flex-shrink: 0;
`;

const StyledAvatarSkeleton = styled(SkeletonAvatar)`
  padding-right: 25px;
`;

const StyledFullNameText = styled(Text)`
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  padding-left: 25px;
  white-space: normal;
  overflow-wrap: normal;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
